import React, { useState } from "react";

const OpenSidebar = () => {
  const [openSidebar, setOpenSidebar] = useState(false);
  return { openSidebar, setOpenSidebar };
};

export default OpenSidebar;
